/**
 * @param {*} id del operando
 */
export default function (id) {
  const option = {
    name: `Op${id}u`,
    action: (editor) => {
      const cm = editor.codemirror;
      const selectedText = cm.getSelection();
      const text = selectedText;

      const output = `/op${id}u/${text}/op${id}u/`;
      cm.replaceSelection(output);
    },
    className: `zmdi zmdi-n-${id}-square`,
    title: `Op${id}u`,
  };

  return option;
}
